import React from "react";
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";
import dayjs from "dayjs";

const CustomDatePicker = ({
  name,
  control,
  label,
  required = false,
  rules = {},
  ...props
}) => (
  <Controller
    name={name}
    control={control}
    rules={{ required, ...rules }}
    render={({ field, fieldState: { error } }) => (
      <TextField
        {...field}
        label={label}
        type="date"
        required={required}
        error={!!error}
        helperText={error ? error.message : ""}
        fullWidth
        margin="dense"
        size="small"
        InputLabelProps={{ shrink: true }}
        {...props}
      />
    )}
  />
);

export default CustomDatePicker;